import SearchViewFull from './SearchViewFull';

export default SearchViewFull;
